import { render, staticRenderFns } from "./Client.vue?vue&type=template&id=ab24ff6c&scoped=true&"
import script from "./Client.vue?vue&type=script&lang=js&"
export * from "./Client.vue?vue&type=script&lang=js&"
import style0 from "./Client.vue?vue&type=style&index=0&id=ab24ff6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab24ff6c",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/PlaylistCard/Client.vue
// module id = null
// module chunks = 